<div class="td-wb-clear-field">
  <ng-content select="[tdWbInput]" />
  @if (displayClearButton()) {
    <div class="td-wb-clear-field__button-wrap">
      <button type="button"
              [attr.aria-label]="'tdWb.button.CLEAR' | translate"
              id="clearButton"
              tdWbIconButton
              tdWbIconButtonSize="small"
              tdWbIconButtonBackground="clear-tint"
              class="td-wb-clear-field__button"
              (click)="clearFieldAndFocus()">
        <td-wb-icon class="td-wb-clear-field__icon"
                    size="12"
                    iconId="close--small" />
      </button>
    </div>
  }
</div>
